import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // Toggle dropdown visibility
  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  // Change language and close dropdown
  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setDropdownOpen(false);
  };

  return (
    <div className={styles.langSwitcher}>
      <button onClick={toggleDropdown} className={styles.langButton}>
        <img src="/assets/images/language.svg" alt="Language" />
        <span>{i18n.language.toUpperCase()}</span>
      </button>

      {isDropdownOpen && (
        <ul className={styles.dropdown}>
          <li onClick={() => changeLanguage('en')}>English</li>
          <li onClick={() => changeLanguage('he')}>עברית</li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;

